/* gk-coupon */
if (!customElements.get('gk-coupon')) {
  class GkCoupon extends HTMLElement {
    connectedCallback() {
      this.code = this.dataset.code || '';
      this.copyLabel = this.dataset.copyLabel || 'COPIAR';
      this.copiedLabel = this.dataset.copiedLabel || 'COPIADO!';
      this.button = this.querySelector('[data-gkc-copy]');
      this.btnText = this.querySelector('[data-gkc-text]');
      if (!this.button) return;
      this.button.addEventListener('click', () => this.copy());
    }

    async copy() {
      const txt = this.code;
      if (!txt) return;
      let ok = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(txt);
          ok = true;
        } else {
          const ta = document.createElement('textarea');
          ta.value = txt;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          ok = true;
        }
      } catch (e) {
        ok = false;
      }

      if (ok) this.flashCopied();
    }

    flashCopied() {
      this.classList.add('is-copied');
      if (this.btnText) this.btnText.textContent = this.copiedLabel;
      clearTimeout(this._t);
      this._t = setTimeout(() => {
        this.classList.remove('is-copied');
        if (this.btnText) this.btnText.textContent = this.copyLabel;
      }, 1800);
    }
  }
  customElements.define('gk-coupon', GkCoupon);
}
